<template>
  <div v-if="showTimeoutModal">
    <TimeoutModal
      :minutesUntilTimeout="minutesUntilTimeout"
      @userIsStillHere="userIsStillHereHandler"
    >
      <template #body>{{ getBodyMessage }}</template>
    </TimeoutModal>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
} from "vue";
import TimeoutModal from "@/apps/merchant3/shared-components/ui/TimeoutModal.vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { ProductVersion } from "@/apps/merchant3/types/ProductVersion";
import { cancelCartAndClearStore } from "@/apps/merchant3/helpers/cancelCart.helper";
import { CancellationReason } from "@/apps/merchant3/types/CancellationReason";

export default defineComponent({
  name: "SaleTimeout",
  props: {
    minutesToShowTimeoutModal: { type: Number, default: 6 },
    minutesUntilTimeout: { type: Number, default: 1 },
    bodyMessage: { type: String },
  },
  components: {
    TimeoutModal,
  },
  setup(props) {
    const { t } = useI18n();
    const store = useStore();
    const showTimeoutModal = ref(false);
    const getBodyMessage = computed(() => {
      return props.bodyMessage
        ? props.bodyMessage
        : t("SHARED.SESSION_TIMEOUT_MODAL_BODY", {
            value: 1,
            text: t("SHARED.MINUTE"),
          });
    });

    const milisecondsToShowTimeoutModal = ref(
      props.minutesToShowTimeoutModal * 60000
    );

    const timeout = ref();
    const resetTimer = () => {
      clearTimeout(timeout.value);
      timeout.value = setTimeout(() => {
        showTimeoutModal.value = true;
      }, milisecondsToShowTimeoutModal.value);
    };

    const events = ["mousemove", "keypress", "touchstart"];

    const addListeners = () => {
      events.forEach((event) => {
        window.addEventListener(event, resetTimer);
      });
    };

    const isSelfOnboarding = computed(() => {
      return (
        store.state.carts?.productVersion == ProductVersion.M3_SELF_ONBOARDING
      );
    });

    onMounted(() => {
      if (isSelfOnboarding.value) {
        addListeners();
        resetTimer();
      }
    });

    const userIsStillHereHandler = (userIsStillHere) => {
      if (userIsStillHere) {
        showTimeoutModal.value = false;
        resetTimer();
      } else {
        cancelCartAndClearStore(CancellationReason.SALE_TIMED_OUT);
      }
    };

    const removeListeners = () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };

    onBeforeUnmount(() => {
      clearTimeout(timeout.value);
      removeListeners();
    });

    return { t, showTimeoutModal, getBodyMessage, userIsStillHereHandler };
  },
});
</script>
